import {
    FETCH_LOYALTY_PROGRAM_RESTAURANTS,
    ADD_RESTAURANT_TO_LOYALTY_PROGRAM,
    REMOVE_RESTAURANT_FROM_LOYALTY_PROGRAM
} from '../types';
import api from '../api';

export const fetchLoyaltyProgramRestaurants = (loyaltyProgramId, restaurantsIds) => {
    return {
        type: FETCH_LOYALTY_PROGRAM_RESTAURANTS,
        payload: api.loyaltyProgram.get(loyaltyProgramId).restaurants.getFull(restaurantsIds),
    };
};

export const addRestaurantsToLoyaltyProgram = (loyaltyProgramId, restaurant) => {
    return {
        type: ADD_RESTAURANT_TO_LOYALTY_PROGRAM,
        payload: api.loyaltyProgram.get(loyaltyProgramId).restaurants.add(restaurant)
    };
};

export const removeRestaurantFromLoyaltyProgram = (loyaltyProgramId, restaurantId) => {
    return {
        type: REMOVE_RESTAURANT_FROM_LOYALTY_PROGRAM,
        payload: api.loyaltyProgram.get(loyaltyProgramId).restaurants.remove(restaurantId)
    };
};